import { render, staticRenderFns } from "./RegisteredWithoutToken.vue?vue&type=template&id=bd806554"
import script from "./RegisteredWithoutToken.vue?vue&type=script&lang=ts"
export * from "./RegisteredWithoutToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_d42ce3051c75faa7db91f2390d07a734/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports